import 'bootstrap/dist/css/bootstrap.min.css';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import '../../assets/css/shards-dashboards.min.css';
import Login from '../pages/Auth/Login';
import Register from '../pages/Auth/Register';
import Landing from '../pages/Landing/Landing';
import './App.css';
import NavbarComp from './Navbar/Navbar';
import routes from './routes';
import ErrorPage from '../pages/404Page/ErrorPage';
import { Announcement } from '../pages/Announcement/Announcement';

const PrivateRoute = ({ component: Component, authenticated, ...rest }) => (
  <Fragment>
    <NavbarComp />
    <Route
      {...rest}
      render={(props) =>
        authenticated === true ? (
          <Component {...props} />
        ) : (
          <Redirect to='/login' />
        )
      }
    />
  </Fragment>
);
const mapState = (state) => ({
  auth: state.firebase.auth,
});

export const PublicRoute = ({ authenticated, ...props }) => {
  //console.log('props', props);
  return authenticated ? (
    <Redirect to='/dashboard/main' />
  ) : (
    <Route {...props} />
  );
};

export class App extends Component {
  render() {
    const { auth } = this.props;
    const authenticated = auth.isLoaded && !auth.isEmpty;

    // Change back to normal in production

    return (
      <Fragment>
        <Switch>
          <PublicRoute
            // authenticated={authenticated}
            exact
            path='/'
            component={Landing}
          />
          <PublicRoute
            authenticated={authenticated}
            component={Login}
            path='/login'
          />
          <PublicRoute
            authenticated={authenticated}
            component={Register}
            path='/register'
          />
         {/* <PublicRoute
            authenticated={authenticated}
            component={Announcement}
            path='/'
          /> */}
        </Switch>

        <Route
          path='/(.+)'
          render={() => (
            <Switch>
              {routes.map((route, index) => {
                return (
                  <PrivateRoute
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    authenticated={authenticated}
                    component={(props) => {
                      return (
                        <route.layout {...props}>
                          <route.component {...props} />
                        </route.layout>
                      );
                    }}
                  />
                );
              })}
            </Switch>
          )}
        />
      </Fragment>
    );
  }
}

export default connect(mapState, null)(App);
